export const CDNURL = 'https://dmevq6vd3sz66.cloudfront.net/';
